<template>
  <el-dialog
    :visible="visible"
    width="400px"
    top="15%"
    append-to-body
    @close="visible = false"
  >
    <div class="dialog_body">
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          padding-top: 20px;
        "
      >
        <h1>欢迎登录虚拟仿真平台</h1>
      </div>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          padding-top: 10px;
        "
      >
        <span style="width: 60px">账号：</span>
        <el-input v-model="form.userId" placeholder="请输入账号"></el-input>
      </div>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          padding-top: 10px;
        "
      >
        <span style="width: 60px">密码：</span>
        <el-input
          type="password"
          v-model="form.password"
          placeholder="请输入密码"
        ></el-input>
      </div>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          padding-top: 30px;
        "
      >
        <el-button
          type="primary"
          style="background-color: skyblue; border: skyblue; width: 200px"
          @keyup.enter.native="sumbit"
          @click="judgeuser('pt')"
          >登录</el-button
        >
      </div>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          padding-top: 10px;
          padding-bottom: 20px;
        "
      >
        <el-button style="width: 200px" @click="judgeuser('zj')"
          >专家登录
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "Login",
  data () {
    return {
      visible: false,
      form: {
        userId: '',
        password: ''
      },
      params: {
        userId: 'profs',
        password: 'profs@tlsrj.com'
      },
      isRedirect: false
    }
  },
  mounted () {
    this.$root.$on('onLoginShow', (isRedirect) => {
      this.onShow(isRedirect);
    })
  },
  methods: {
    onShow (isRedirect) {
      this.isRedirect = isRedirect ? isRedirect : false;
      this.visible = true;
    },
    judgeuser (role) {
      //TODO:专家登录应请求新接口，账号从专家账号池里取
      if (role === 'zj') {
        this.loginsys(this.params)
      } else {
        this.loginsys(this.form)
      }
    },
    loginsys (obj) {
      const that = this;
      let url = '/facade/login';
      let params = obj;
      this.$axios.post(url, params).then((resp) => {

        if (resp.data.code === 200) {

          let jwt = require('jsonwebtoken')
          let userform = JSON.parse(jwt.decode(resp.data.result.token).payload)

          that.loginGetInto(userform, resp.data.result.token)

          // let cookie = document.cookie;
          // let JSESSIONID = cookie.split("JSESSIONID=")[1];

          // localStorage.setItem('JSESSIONID', JSESSIONID);
          // console.log("SESSION ID => " + JSESSIONID);
          // localStorage.setItem('username', resp.data.result.userName);
          // console.log('用户' + resp.data.result.userName)
          // this.$message.success('登陆成功！');
          // if (resp.data.result.userName !== 'root') {
          //   this.$router.push({ path: "/" }).catch(() => { })// eslint-disable-line
          // } else {
          //   this.$router.push({ path: "/class" }).catch((e) => {
          //     console.log(e)
          //   })// eslint-disable-line
          // }
        } else {
          this.$message.error(resp.data.message)
        }
      })
    },
    loginGetInto (userform, token) {

      this.setItems(userform, token)

      if (this.isVerification === 0 && this.isRememberPassword) {
        this.setCookie("account", userform.userId, 7 * 24 * 60 * 60 * 1000)
        // base64加密密码
        let passWord = Base64.encode(this.form.getFieldValue('password'))
        this.setCookie("remember", passWord, 7 * 24 * 60 * 60 * 1000)
      } else {
        this.setCookie("account", "")
        this.setCookie("remember", "")
      }

      this.visible = false;

      if (userform.userType === "Student" || userform.userType === "DeclareProfs") {
        if (!this.isRedirect) {
          window.location.reload();
          return;
        } else {
          this.$RedirectTlszxSoftware();
        }
      } else if (userform.userType === "Teacher") {
        this.$RedirectTlszxPlace("/teacher/page/index");
      } else if (userform.userType === "Administrator") {
        this.$RedirectTlszxPlace("/management/user/institutions");
      } else {
        this.$message.error(`未知的用户类型【${userform.userType}】！`);
      }
    },
    setItems (userform, token) {
      localStorage.setItem('signature', userform.signature)
      localStorage.setItem('accessToken', token)
      localStorage.setItem('userform', JSON.stringify(userform))
      localStorage.setItem('userType', userform.userType)
      localStorage.setItem('declare', "TRUE")

      let params = userform.params;
      let keys = Object.keys(params);

      keys.forEach(key => {
        localStorage.setItem(key, params[key])
      })
    },
    setCookie (cName, value, expiredays) {
      var exdate = new Date()
      exdate.setTime(exdate.getTime() + expiredays)
      document.cookie = cName + '=' + decodeURIComponent(value) + ';path=/' +
        ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString());
    }
  },
}
</script>

<style scoped>
.dialog_body {
  width: 100%;
  height: 320px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: rgb(255, 255, 255);
  border: 1px solid skyblue;
  border-radius: 15px;
}
::v-deep .el-dialog {
  border-radius: 15px;
}
::v-deep .el-dialog__body {
  padding: 2px;
}
::v-deep .el-dialog__header {
  padding: 0;
}
</style>
